<div class="password-input" [ngClass]="{ 'has-error': formCtrl.touched && formCtrl.invalid }">
  <input
    id="{{ id }}"
    [formControl]="formCtrl"
    [type]="isPasswordVisible ? 'text' : 'password'"
    [placeholder]="placeholder"
    class="custom-password-input"
    (keyup)="onChange()"
    (change)="onChange()"
    [attr.data-testid]="dataTestId"
  />
  <app-icon
    class="toggle-password-visibility"
    [phosphorClass]="'ph-' + (isPasswordVisible ? 'eye' : 'eye-closed')"
    id="togglePasswordVisibility"
    (click)="onTogglePasswordVisibility()"
    tabindex="0"
    (keydown)="onTogglePasswordVisibility()"
  ></app-icon>
</div>
